import { Component, OnInit, NgZone, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { SessionService } from '@core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {
    private readonly ngZone = inject(NgZone);
    private readonly sessionService = inject(SessionService);

    public planName$: Observable<string>;

    constructor() {
        // Exposed public method for Profil to send authentication info
        window['angularAppComponent'] = {
            initSession: (requestId: string, username: string, apiKey: string) =>
                this.initSession(requestId, username, apiKey)
        };
    }

    ngOnInit(): void {
        this.planName$ = this.sessionService.getPlanName();
    }

    public initSession(requestId: string, username: string, apiKey: string, bearerToken?: string) {
        this.ngZone.run(() => {
            this.sessionService.setSession(requestId, username, apiKey, bearerToken);
        });
    }
}
